import { SxProps } from '@mui/material';
import { blue, grey8 } from 'app/components/ThemeProvider/colors';

export const infoText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '26px',
  mb: '12px',
  fontWeight: '600',
};
export const descText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '17px',
  mb: '34px',
  fontWeight: '400',
  color: grey8,
};

export const btnBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
};

export const resendLink: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '15px',
  fontWeight: '400',
  color: blue,
  mt: '28px',
  cursor: 'pointer',
  p: 0,
};
